import { lazyModule } from '@servicetitan/lazy-module';
import { FC } from 'react';
import { PageLoading } from '../../page-layout';

const loader = async () => {
    const { PageCase } = await import(
        /* webpackChunkName: "case" */
        './page-case'
    );

    return PageCase;
};

const PageCaseLazy = lazyModule({ loader, name: 'Case', loadingComponent: PageLoading });

export const PageCase: FC = () => <PageCaseLazy />;
